import { render, staticRenderFns } from "./part-radio-list.vue?vue&type=template&id=0f9c9e96&scoped=true&lang=pug"
import script from "./part-radio-list.vue?vue&type=script&lang=js"
export * from "./part-radio-list.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f9c9e96",
  null
  
)

export default component.exports